<template>
  <button
    :class="variant"
    :disabled="disabled"
    class="icu-btn"
    @click="$emit('click')"
  >
    <icu-icon v-if="iconLeftName" class="icu-btn__icon" :icon-name="iconLeftName" />
    <slot></slot>
    <icu-icon v-if="iconRightName" class="icu-btn__icon" :icon-name="iconRightName" />
  </button>
</template>

<script>
import IcuIcon from '@/components/common/IcuIcon.vue'
export default {
  name: 'IcuButton',
  components: { IcuIcon },
  props: {
    variant: {
      type: String,
      default: 'filled'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    iconLeftName: {
      type: String,
      default: ''
    },
    iconRightName: {
      type: String,
      default: ''
    },
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/components/common/IcuButton.scss";
</style>
